import { ModalOverlay } from './ModalOverlay';
import { isPaperThemeActive } from '@/hooks/useThemeFlag';

interface DemoSignInPromptProps {
  onSignIn: () => void;
  onCancel: () => void;
}

export const DemoSignInPrompt = ({ onSignIn, onCancel }: DemoSignInPromptProps) => {
  if (isPaperThemeActive()) {
    return (
      <ModalOverlay onBackdropClick={onCancel} className="z-[70] px-4" cardClassName="p-5">
        <p className="text-[14px] font-medium text-[var(--fg)]">Sign in to interact</p>
        <p className="mt-1.5 text-[13px] leading-relaxed text-[var(--fg-3)]">
          This is a demo preview. Sign in to chat with it or create your own agents.
        </p>
        <div className="mt-4 flex flex-col gap-2">
          <button
            type="button"
            onClick={onSignIn}
            className="inline-flex items-center justify-center h-[34px] w-full rounded-full text-[12px] font-medium tracking-[0.02em] cursor-pointer bg-[var(--fg)] text-[var(--fg-inverse)] border border-solid border-[var(--fg)] transition-colors duration-200 hover:bg-[var(--ink-3)] hover:border-[var(--ink-3)]"
          >
            Sign in
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center h-[34px] w-full rounded-full text-[12px] font-medium tracking-[0.02em] cursor-pointer bg-transparent text-[var(--fg)] border border-solid border-[var(--hair)] transition-colors duration-200 hover:bg-[var(--periwinkle-wash)] hover:text-[var(--periwinkle)] hover:border-[var(--periwinkle)]"
          >
            Cancel
          </button>
        </div>
      </ModalOverlay>
    );
  }

  return (
    <ModalOverlay onBackdropClick={onCancel} className="z-[70] px-4" cardClassName="p-5">
      <p className="text-[13px] font-medium text-zinc-200">Sign in to interact</p>
      <p className="mt-1.5 text-[13px] leading-relaxed text-zinc-500">
        This is a demo preview. Sign in to chat with it or create your own agents.
      </p>
      <div className="mt-4 flex flex-col gap-2">
        <button
          type="button"
          onClick={onSignIn}
          className="flex h-9 w-full items-center justify-center rounded-lg bg-white/[0.1] px-4 text-[13px] font-medium text-zinc-100 transition-colors hover:bg-white/[0.16]"
        >
          Sign in
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="flex h-9 w-full items-center justify-center rounded-lg px-4 text-[13px] text-zinc-400 transition-colors hover:bg-white/[0.06] hover:text-zinc-200"
        >
          Cancel
        </button>
      </div>
    </ModalOverlay>
  );
};
